import GroupOfficerOfficerTypes from './group-officer-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// FETCH GROUP OFFICER RESPONSE
	fetchAllGroupOfficerReportResp: null,
	fetchAllGroupOfficerReportArr: [],

	// FETCH ALL CENTER LIST BASED ON OFFICER RESPONSE
	fetchAllCenterListForOfficerResp: null,
	fetchAllCenterListForOfficerArr: [],
};

const groupOfficerReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/***************** GET GROUP OFFICER REPORT  START *************** */
		case GroupOfficerOfficerTypes.GET_GROUP_OFFICER_REPORT_SUCCESS:
			return {
				...state,
				fetchAllGroupOfficerReportResp: action.payload,
				fetchAllGroupOfficerReportArr: docodeHexResponse(
					action.payload,
					'GetAllGroupOfficerReportKey',
				),
			};

		case GroupOfficerOfficerTypes.GET_GROUP_OFFICER_REPORT_FAILURE:
			return { ...state, fetchAllGroupOfficerReportResp: action.payload };

		case GroupOfficerOfficerTypes.GET_GROUP_OFFICER_REPORT_RESPONSE_RESET_CHANGED:
			return { ...state, fetchAllGroupOfficerReportResp: null };
		/***************** GET GROUP OFFICER REPORT  END *************** */

		/***************** GET GROUP OFFICER REPORT  START *************** */
		case GroupOfficerOfficerTypes.GET_CENTER_LIST_FOR_OFFICER_SUCCESS:
			return {
				...state,
				fetchAllCenterListForOfficerResp: action.payload,
				fetchAllCenterListForOfficerArr: docodeHexResponse(
					action.payload,
					'GetAllCenterListForOfficerKey',
				),
			};

		case GroupOfficerOfficerTypes.GET_CENTER_LIST_FOR_OFFICER_FAILURE:
			return { ...state, fetchAllCenterListForOfficerResp: action.payload };

		case GroupOfficerOfficerTypes.GET_CENTER_LIST_FOR_OFFICER_RESPONSE_RESET_CHANGED:
			return { ...state, fetchAllCenterListForOfficerResp: null };
		/***************** GET GROUP OFFICER REPORT  END *************** */

		default:
			return state;
	}
};

export default groupOfficerReportReducer;
